import PropTypes from "prop-types"
import React from "react"
import { useQuery } from "react-query"
import { useMarina } from "src/contexts/MarinaContext"

import InlineNotice from "src/components/InlineNotice"
import Loader from "src/components/Loader"

import { getPaymentTxn } from "src/api/Billing/Payments"

import PaymentAppliedTo from "./PaymentAppliedTo"
import PaymentHeader from "./PaymentHeader"
import PaymentStats from "./PaymentStats"
import PaymentStatusNotice from "./PaymentStatusNotice"
import PaymentTimeline from "./PaymentTimeline"

const PaymentDetail = ({ paymentTxnId }) => {
  const { marinaSlug } = useMarina()
  const {
    data: payment,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["paymentTxn", marinaSlug, paymentTxnId],
    queryFn: () => getPaymentTxn({ marinaSlug, paymentTxnId }),
  })

  if (isLoading) return <Loader name="payment" />
  if (isError)
    return (
      <div className="mx-auto max-w-[860px] px-4 py-6">
        <InlineNotice variant="error">
          We couldn’t load this payment. Try refreshing the page.
        </InlineNotice>
      </div>
    )

  return (
    <div className="mx-auto flex max-w-[1200px] flex-col gap-6 px-4 pb-6">
      <PaymentHeader payment={payment} />
      <PaymentStatusNotice status={payment.status} />
      <PaymentStats payment={payment} />
      <PaymentAppliedTo
        invoices={
          payment.timeline.find((event) => event.kind === "payment").invoices
        }
      />
      <PaymentTimeline payment={payment} />
    </div>
  )
}

PaymentDetail.propTypes = {
  paymentTxnId: PropTypes.string.isRequired,
}

export default PaymentDetail
